import { defineBoot } from '#q-app'
import { createI18n } from 'vue-i18n'
import messages from '@/i18n'

export const i18n = createI18n({
  locale: 'en',
  globalInjection: true,
  messages
})

export default defineBoot(({ app }) => {
  app.use(i18n)
})
